import { Subject } from 'rxjs';

export const imageUploadSubject = new Subject<{
  url: string;
  height: number;
  width: number;
}>();

export const imageUploadFlagEvent = new Subject<boolean>();
